export const select = (theme) => {
    return {
        sizes: {
            md: '32px',
            lg: '40px',
        },
        variants: {
            regular: {
                border: `1px solid ${theme.colors?.border.control}`,
                focus: {
                    border: `1px solid ${theme.colors?.border.focus}`,
                    boxShadow: `0px 0px 0px 1px ${theme.colors?.border.focus}`,
                },
                hover: {
                    border: `1px solid ${theme.colors?.border.control}`,
                },
                error: {
                    border: `1px solid ${theme.colors?.border.danger}`,
                    boxShadow: `0px 0px 0px 1px ${theme.colors?.border.danger}`,
                },
                disabled: {
                    background: theme.colors?.component.disabled,
                    border: `1px solid transparent`,
                    color: theme.colors?.text.basic.disabled,
                },
            },
            subtle: {
                border: `1px solid transparent`,
                hover: {
                    border: `1px solid ${theme.colors?.border.control}`,
                },
                focus: {
                    border: `1px solid ${theme.colors?.border.focus}`,
                    boxShadow: `0px 0px 0px 1px ${theme.colors?.border.focus}`,
                },
                error: {
                    border: `1px solid ${theme.colors?.border.danger}`,
                    boxShadow: `0px 0px 0px 1px ${theme.colors?.border.danger}`,
                },
                disabled: {
                    background: 'transparent',
                    border: `1px solid transparent`,
                    color: theme.colors?.text.basic.disabled,
                },
            },
        },
    };
};
//# sourceMappingURL=select.js.map